import React from 'react'
import ShoppingCartList from './ShoppingCartList'



function ShoppingCard() {

// Variables




  return (
    <div className='shoppingCard'>

        <ShoppingCartList />

    </div>
  )
}

export default ShoppingCard